/*@ngInject*/
const CollaborationEmailRepository = function (baseRepository, attachmentUtil) {

    angular.extend(this, baseRepository);

    this.loadCollaborationEmail = function (emailId) {
        let url = '/rest/Email/' + emailId;

        return this.get(url);
    };
};

angular.module('gw-um-submission')
    .service('collaborationEmailRepository', CollaborationEmailRepository);
